const Home=()=>{
    return(
        <div>
            <h1>Bienvenue</h1>
        </div>
    )
}
export default Home